import { DeepPartial, ScrollConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_SCROLL_CONFIG: DeepPartial<ScrollConfig> = {
  scrollPanelSelector: '.ebx-empathy-x__main',
  minimumDeltaInPx: 5,
  scrollOffsetInPx: 200
};
